export default "__VITE_ASSET__7756024c__"